////
/// ============================================================================
/// COMPONENT / Carousel
/// ============================================================================
///
/// @group components
////

import Flickity from "flickity";

export default () => {

    /**
     * Full Carousel (Pathology, Location)
     */
    (function () {
        let container = document.querySelectorAll('.js-fullcarousel');

        if (!container) {
            return;
        }

        container.forEach((element) => {
            new Flickity(element, {
                autoPlay: false,
                pauseAutoPlayOnHover: false,
                adaptiveHeight: false,
                cellAlign: 'center',
                prevNextButtons: false,
                wrapAround: true,
                percentPosition: true
            });
        });
    }());

    /**
     * News
     */
    (function () {
        let container = document.querySelector('.js-news');

        if (!container) {
            return;
        }

        let flky = new Flickity(container, {
            autoPlay: false,
            pauseAutoPlayOnHover: false,
            watchCSS: true,
            adaptiveHeight: true,
            cellAlign: 'left',
            prevNextButtons: false,
            groupCells: true
        });
    }());

};
